// Campana con contador real de no-leídas (Flujo Contacto #2).
//
// Existe como componente compartido porque el badge estaba hardcodeado en
// varias superficies del scout: un puntito rojo fijo que aparecía siempre,
// hubiera o no algo que leer. Un indicador que siempre está encendido no
// informa nada, y entrena al usuario a ignorarlo.
//
// El conteo sale de la misma query que alimenta el panel, así que el badge y la
// lista nunca se contradicen; useNotificationStream (montado en AppShell) la
// invalida cuando el servidor empuja, así que esto se actualiza solo.
import React from "react";
import { Bell } from "lucide-react";

import { useNotifications } from "../../hooks/queries/useNotifications";

const NotificationBell = ({
  onClick,
  size = 20,
  className = "",
  iconClassName = "text-gray-700",
  "aria-label": ariaLabel = "Notificaciones",
}) => {
  const { data: notifications } = useNotifications();
  const unread = (notifications || []).filter((n) => !n.read).length;

  return (
    <button
      type="button"
      onClick={onClick}
      data-analytics-id="header-notifications"
      aria-label={
        unread > 0 ? `${ariaLabel} (${unread} sin leer)` : ariaLabel
      }
      className={`relative rounded-lg p-2 transition-colors hover:bg-gray-200 ${className}`}
    >
      <Bell size={size} className={iconClassName} />
      {unread > 0 && (
        <span
          // 9+ en vez de un número largo: el badge vive sobre el ícono y un
          // "23" lo desborda.
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
